export const da = {
  returnLineItems: {
    refund: "Refundering(er)",
    exchange: "Ombytning(er)",
    discount: "Rabat(ter)",
  },
  returnStoreAddress: {
    mapButton: "Se på kort",
  },
  downloadLabel: {
    label: "Download min etiket",
    bonDeRetour: "Download min returseddel",
  },
  returnRequestDate: {
    label: "Din returanmodning blev oprettet den {{date}} kl. {{time}}",
  },
  actions: {
    continue: "Fortsæt",
  },
  "order-identification": {
    title: "Spor din ordre",
    description: "Indtast dine ordreoplysninger for at spore din pakke",
    fields: {
      "zip-code": {
        title: "Postnummer",
        description: "Indtast dit leveringspostnummer",
        required: "Postnummer er påkrævet",
      },
      "tracking-number": {
        title: "Ordrenummer",
        description: "Indtast dit ordrenummer",
        required: "Ordrenummer er påkrævet",
      },
    },
    errors: {
      "unknown-order": {
        title: "Ukendt ordrenummer",
        description: "Ordrenummeret blev ikke fundet, kontroller det venligst",
      },
      "search-error": {
        title: "Søgefejl",
        description: "Vi kunne ikke finde ordren. Prøv venligst igen senere.",
      },
    },
  },
  delivery: "Levering",
  "parcel-history": "Pakkehistorik",
  "order-details": {
    title: "Ordredetaljer",
    "tracking-number": "Sporingsnummer",
    "order-number": "Ordrenummer",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Forventet leveringsdato",
      deliveredOn: "Leveret den",
      from: "fra",
      to: "til",
    },
  },
  deliveryAddress: {
    title: "Leveringsadresse:",
    titlePickup: "Adresse på afhentningssted:",
    orderDetails: {
      title: "Ordredetaljer:",
      trackingNumber: "Sporingsnummer:",
      orderNumber: "Ordrenummer:",
      orderDate: "Ordredato:",
    },
  },
  pickupPoint: {
    title: "Afhentningssted",
    openingHours: "Åbningstider:",
    closed: "Lukket",
    directions: "Vejbeskrivelse",
    days: {
      monday: "Mandag:",
      tuesday: "Tirsdag:",
      wednesday: "Onsdag:",
      thursday: "Torsdag:",
      friday: "Fredag:",
      saturday: "Lørdag:",
      sunday: "Søndag:",
    },
  },
  wallet: {
    warningNotEnabled: "Du skal aktivere Wallet i dine butiksindstillinger",
  },
  crossSell: {
    youMightAlsoLike: "Du vil måske også kunne lide",
  },
  "rate-order": {
    "order-recap": {
      title: "Din ordre",
      "tracking-label": "Sporingsnummer:",
      "order-label": "Ordrenummer:",
    },
    form: {
      title: "Bedøm din levering",
      "rating-label": "Bedøm din leveringsoplevelse",
      "comment-label": "Kommentar (valgfri)",
      "comment-placeholder": "Del din oplevelse med os…",
      "submit-cta": "Indsend min anmeldelse",
      "update-cta": "Opdater min anmeldelse",
      "rating-required": "Vælg venligst en bedømmelse.",
    },
    "thank-you": {
      title: "Tak for din feedback!",
      description:
        "Din anmeldelse er blevet gemt. Den vil hjælpe os med at forbedre leveringsoplevelsen.",
    },
    errors: {
      "invalid-token": {
        title: "Ugyldigt eller udløbet link",
        description:
          "Dette link er ikke længere gyldigt. Åbn det igen fra din seneste sporings-e-mail.",
      },
      submit: {
        title: "Noget gik galt",
        description:
          "Vi kunne ikke gemme din anmeldelse. Prøv venligst igen senere.",
      },
    },
  },
  shippingInstructions: {
    colissimo: "Du kan nu printe din returlabel og aflevere din pakke på det nærmeste Colissimo-udleveringssted.",
    chronoShop2Shop: "Du kan nu printe din returlabel og aflevere din pakke på det nærmeste Chronopost-udleveringssted.",
    ups: "Du kan nu printe din returlabel og aflevere din pakke på det nærmeste UPS-udleveringssted.",
    customerCarrier: "Du kan nu sende din returpakke med det fragtfirma, du ønsker.",
    merchantCarrier: "Vi sender dig en returlabel pr. e-mail inden for 1 til 3 hverdage.",
    returnToStore: "Du kan nu aflevere din pakke i den nærmeste butik.",
    malca: "Du kan nu printe din returlabel og aflevere din pakke på det nærmeste Malca-udleveringssted.",
    tnt: "Du kan nu printe din returlabel og aflevere din pakke på det nærmeste TNT-udleveringssted.",
    bonDeRetour: "Din fragtlabel er klar. Du kan nu printe den og bruge den til din returnering.",
  },
  shippingInstructionsTitle: {
    shippingLabel: "Din forsendelsesetiket er klar",
    bonDeRetour: "Din returseddel er klar",
  },
} as const;
